(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-launch-countdown"] && !Shopify.designMode) return;
  try {
    
  class CHLaunchCountdown {
    constructor(section) {
      this.section = section;
      this.days = section.querySelector('[data-countdown-days]');
      this.hours = section.querySelector('[data-countdown-hours]');
      this.minutes = section.querySelector('[data-countdown-minutes]');
      this.seconds = section.querySelector('[data-countdown-seconds]');
      this.pending = section.querySelector('[data-countdown-pending]');
      this.completeState = section.querySelector('[data-countdown-complete]');
      this.target = new Date(section.dataset.launchAt).getTime();

      if (!this.target || Number.isNaN(this.target)) return;

      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        window.clearInterval(this.interval);
        this.setValues(0, 0, 0, 0);
        this.showCompleteState();
        return;
      }

      this.section.dataset.countdownState = 'pending';

      const seconds = Math.floor(remaining / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      this.setValues(days, hours, minutes, secs);
    }

    setValues(days, hours, minutes, seconds) {
      const pad = (value) => String(value).padStart(2, '0');
      if (this.days) this.days.textContent = String(days);
      if (this.hours) this.hours.textContent = pad(hours);
      if (this.minutes) this.minutes.textContent = pad(minutes);
      if (this.seconds) this.seconds.textContent = pad(seconds);
    }

    showCompleteState() {
      this.section.dataset.countdownState = 'complete';
      if (this.pending) this.pending.hidden = true;
      if (this.completeState) this.completeState.hidden = false;
    }
  }

  document.querySelectorAll('.ch-launch-countdown').forEach((section) => {
    if (section.dataset.countdownReady === 'true') return;
    section.dataset.countdownReady = 'true';
    new CHLaunchCountdown(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-launch-flipbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const flipbookSelector = '[data-ch-launch-flipbook]';
    const initVersion = 'swipe-trigger-v12';
    const activeClass = 'is-active';
    const previewTurnClass = 'is-previewing-turn';
    const mobileVisiblePageClass = 'is-mobile-visible-page';
    const animatingClass = 'is-animating';
    const animatingNextClass = 'is-animating-next';
    const animatingPrevClass = 'is-animating-prev';
    const turnNextClass = 'is-turning-next';
    const turnPrevClass = 'is-turning-prev';
    const turnFastClass = 'is-turning-fast';
    const dragClass = 'is-dragging';
    const turnDuration = 1350;
    const acceleratedPlaybackRate = 4;
    const dragThreshold = 40;

    function initLaunchFlipbook(section) {
      if (section.dataset.flipbookInitVersion === initVersion) return;

      if (section.dataset.flipbookInit && section.dataset.flipbookInitVersion !== initVersion) {
        const oldBook = section.querySelector('[data-flipbook-book]');
        const oldPreviousButton = section.querySelector('[data-flipbook-prev]');
        const oldNextButton = section.querySelector('[data-flipbook-next]');

        oldBook?.replaceWith(oldBook.cloneNode(true));
        oldPreviousButton?.replaceWith(oldPreviousButton.cloneNode(true));
        oldNextButton?.replaceWith(oldNextButton.cloneNode(true));
      }

      const book = section.querySelector('[data-flipbook-book]');
      const dragSurface = section.querySelector('[data-flipbook-drag-surface]');
      const spreads = Array.from(section.querySelectorAll('[data-flipbook-spread]'));
      const pages = Array.from(section.querySelectorAll('[data-flipbook-page]'));
      const turn = section.querySelector('[data-flipbook-turn]');
      const turnFront = section.querySelector('[data-flipbook-turn-front]');
      const turnBack = section.querySelector('[data-flipbook-turn-back]');
      const previousButton = section.querySelector('[data-flipbook-prev]');
      const nextButton = section.querySelector('[data-flipbook-next]');
      const counter = section.querySelector('[data-flipbook-counter]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileMedia = window.matchMedia('(max-width: 749px)');
      let currentSpreadIndex = 0;
      let currentPageIndex = 0;
      let isTurning = false;
      let turnTimer;
      let settleTimer;
      let pendingTurnFinish = null;
      let queuedDirection = null;
      let accelerateOnStart = false;
      let dragStartX = 0;
      let dragStartY = 0;
      let dragPointerId = null;

      if (!book || !dragSurface || !spreads.length || !pages.length || !turn || !turnFront || !turnBack || !previousButton || !nextButton || !counter) return;

      section.dataset.flipbookInit = 'true';
      section.dataset.flipbookInitVersion = initVersion;

      function isMobileMode() {
        return mobileMedia.matches && pages.length > 0;
      }

      function pageAt(index) {
        return pages[Math.max(0, Math.min(index, pages.length - 1))];
      }

      function pageInSpread(spreadIndex, side) {
        const pageIndex = (spreadIndex * 2) + (side === 'right' ? 1 : 0);
        return pageAt(pageIndex);
      }

      function warmImages(container) {
        return Promise.all(
          Array.from(container.querySelectorAll('img')).map(decodeImage)
        );
      }

      function prepareClonedPage(page) {
        const clone = page.cloneNode(true);
        clone.classList.add(mobileVisiblePageClass);
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('img').forEach((image) => {
          image.loading = 'eager';
          image.decoding = 'sync';
        });
        return clone;
      }

      function setTurnFaces(frontPage, backPage) {
        turnFront.replaceChildren(prepareClonedPage(frontPage));
        turnBack.replaceChildren(prepareClonedPage(backPage));
        return Promise.all([warmImages(turnFront), warmImages(turnBack)]);
      }

      function clearTurn() {
        clearTimeout(settleTimer);
        turn.classList.remove(turnNextClass, turnPrevClass, turnFastClass);
        turn.style.removeProperty('animation-delay');
        turn.style.removeProperty('animation-play-state');
        turnFront.replaceChildren();
        turnBack.replaceChildren();
        section.classList.remove(animatingClass, animatingNextClass, animatingPrevClass);
        spreads.forEach((spread) => spread.classList.remove(previewTurnClass));
      }

      function setSpreadVisibility(activeSpreadIndex) {
        spreads.forEach((spread, index) => {
          const isActive = index === activeSpreadIndex;
          spread.classList.toggle(activeClass, isActive);
          if (isActive) {
            spread.removeAttribute('aria-hidden');
          } else {
            spread.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function updateVisiblePages(extraPageIndex) {
        const mobileMode = isMobileMode();
        const visiblePageIndex = extraPageIndex ?? currentPageIndex;
        section.classList.toggle('is-mobile-page-mode', mobileMode);
        pages.forEach((page, index) => {
          page.classList.toggle(
            mobileVisiblePageClass,
            !mobileMode || index === visiblePageIndex
          );
        });
      }

      function updateControls(displaySpreadIndex = currentSpreadIndex, displayPageIndex = currentPageIndex) {
        const mobileMode = isMobileMode();
        const maxIndex = mobileMode ? pages.length - 1 : spreads.length - 1;
        const currentIndex = mobileMode ? displayPageIndex : displaySpreadIndex;
        previousButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= maxIndex;
        counter.textContent = `${currentIndex + 1} / ${maxIndex + 1}`;
      }

      function decodeImage(image) {
        if (!image || image.complete) return Promise.resolve();
        if (typeof image.decode === 'function') {
          return image.decode().catch(() => undefined);
        }

        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      }

      function warmSpreadImages(spreadIndex) {
        const spread = spreads[spreadIndex];
        if (!spread) return Promise.resolve();

        return warmImages(spread);
      }

      function commitActive(nextSpreadIndex, nextPageIndex) {
        currentSpreadIndex = nextSpreadIndex;
        currentPageIndex = nextPageIndex;
        setSpreadVisibility(currentSpreadIndex);
        updateVisiblePages();
        updateControls();
      }

      function completePendingTurn() {
        if (!pendingTurnFinish) return;

        const finish = pendingTurnFinish;
        pendingTurnFinish = null;
        finish();
      }

      function accelerateCurrentTurn() {
        if (!isTurning) return false;

        if (typeof turn.getAnimations !== 'function') {
          turn.classList.add(turnFastClass);
          if (!pendingTurnFinish) return false;

          clearTimeout(turnTimer);
          turnTimer = window.setTimeout(completePendingTurn, 360);
          return true;
        }

        const animation = turn.getAnimations().find((candidate) => (
          candidate.playState === 'running' || candidate.playState === 'pending'
        ));
        if (!animation) {
          turn.classList.add(turnFastClass);
          return false;
        }

        const currentTime = typeof animation.currentTime === 'number' ? animation.currentTime : 0;
        const timing = animation.effect?.getTiming?.();
        const duration = typeof timing?.duration === 'number' ? timing.duration : turnDuration;

        if (typeof animation.updatePlaybackRate === 'function') {
          animation.updatePlaybackRate(acceleratedPlaybackRate);
        } else {
          animation.playbackRate = acceleratedPlaybackRate;
        }

        clearTimeout(turnTimer);
        const remainingDuration = Math.max(0, duration - currentTime) / acceleratedPlaybackRate;
        turnTimer = window.setTimeout(completePendingTurn, Math.max(60, remainingDuration + 80));
        return true;
      }

      function finishTurn(nextSpreadIndex, nextPageIndex) {
        commitActive(nextSpreadIndex, nextPageIndex);
        settleTimer = window.setTimeout(() => {
          clearTurn();
          isTurning = false;

          const nextDirection = queuedDirection;
          queuedDirection = null;
          if (nextDirection) {
            window.requestAnimationFrame(() => go(nextDirection));
          }
        }, queuedDirection ? 20 : 90);
      }

      async function prepareTurn(nextSpreadIndex, nextPageIndex, direction) {
        const mobileMode = isMobileMode();

        if (mobileMode) {
          const oldPage = pageAt(currentPageIndex);
          const newPage = pageAt(nextPageIndex);
          const frontPage = direction === 'prev' ? newPage : oldPage;
          const backPage = direction === 'prev' ? oldPage : newPage;

          if (!oldPage || !newPage) return false;
          const turnFacesReady = setTurnFaces(frontPage, backPage);

          // On the way forward, the old-page clone turns away to reveal the
          // next page already in place. On the way back, the new page turns in
          // over the current page.
          updateVisiblePages(direction === 'next' ? nextPageIndex : currentPageIndex);
          spreads[nextSpreadIndex]?.classList.add(previewTurnClass);
          await Promise.all([turnFacesReady, warmSpreadImages(nextSpreadIndex)]);
          return true;
        }

        const frontPage = direction === 'prev'
          ? pageInSpread(nextSpreadIndex, 'right')
          : pageInSpread(currentSpreadIndex, 'right');
        const backPage = direction === 'prev'
          ? pageInSpread(currentSpreadIndex, 'left')
          : pageInSpread(nextSpreadIndex, 'left');

        if (!frontPage || !backPage) return false;
        await Promise.all([setTurnFaces(frontPage, backPage), warmSpreadImages(nextSpreadIndex)]);
        spreads[nextSpreadIndex]?.classList.add(previewTurnClass);
        return true;
      }

      async function setActive(nextSpreadIndex, nextPageIndex, direction) {
        if (isTurning) return;
        if (nextSpreadIndex < 0 || nextSpreadIndex >= spreads.length) return;

        clearTimeout(turnTimer);
        clearTimeout(settleTimer);
        clearTurn();

        if (!reducedMotion.matches) {
          isTurning = true;
          updateControls(nextSpreadIndex, nextPageIndex);
          const turnReady = await prepareTurn(nextSpreadIndex, nextPageIndex, direction);

          if (!turnReady) {
            isTurning = false;
            clearTurn();
            commitActive(nextSpreadIndex, nextPageIndex);
            return;
          }

          section.classList.add(animatingClass, direction === 'prev' ? animatingPrevClass : animatingNextClass);
          turn.classList.add(direction === 'prev' ? turnPrevClass : turnNextClass);
          pendingTurnFinish = () => finishTurn(nextSpreadIndex, nextPageIndex);
          turnTimer = window.setTimeout(completePendingTurn, turnDuration + 100);

          if (accelerateOnStart) {
            accelerateOnStart = false;
            window.requestAnimationFrame(() => accelerateCurrentTurn());
          }
        } else {
          clearTurn();
          commitActive(nextSpreadIndex, nextPageIndex);
          isTurning = false;
        }
      }

      function isHorizontalSwipe(deltaX, deltaY) {
        return Math.abs(deltaX) >= dragThreshold && Math.abs(deltaX) >= Math.abs(deltaY) * 1.2;
      }

      function updateSwipeIntent(deltaX, deltaY, event) {
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (absX < 10 || absX < absY * 1.1) return;

        if (event?.cancelable) {
          event.preventDefault();
        }
      }

      function go(direction) {
        if (isTurning) {
          queuedDirection = direction;
          if (!accelerateCurrentTurn()) {
            accelerateOnStart = true;
          }
          return;
        }

        if (isMobileMode()) {
          const nextPageIndex = currentPageIndex + (direction === 'next' ? 1 : -1);
          if (nextPageIndex < 0 || nextPageIndex >= pages.length) return;
          setActive(Math.floor(nextPageIndex / 2), nextPageIndex, direction);
        } else {
          const nextSpreadIndex = currentSpreadIndex + (direction === 'next' ? 1 : -1);
          setActive(nextSpreadIndex, nextSpreadIndex * 2, direction);
        }
      }

      function shouldIgnoreDragTarget(target) {
        return Boolean(target.closest('button, a, input, textarea, select, summary'));
      }

      function isSwipeTarget(target) {
        return target === book || book.contains(target);
      }

      function resetDrag() {
        dragPointerId = null;
        book.classList.remove(dragClass);
      }

      function onPointerDown(event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (dragPointerId !== null) return;
        if (!isSwipeTarget(event.target)) return;
        if (isTurning || shouldIgnoreDragTarget(event.target)) return;

        event.stopPropagation();
        dragPointerId = event.pointerId === undefined ? 'mouse' : event.pointerId;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        book.classList.add(dragClass);

        if (event.pointerId !== undefined && typeof event.currentTarget?.setPointerCapture === 'function') {
          event.currentTarget.setPointerCapture(event.pointerId);
        }
      }

      function onPointerMove(event) {
        if (dragPointerId === null) return;

        const eventPointerId = event.pointerId === undefined ? 'mouse' : event.pointerId;
        if (dragPointerId !== eventPointerId && !(eventPointerId === 'mouse' && dragPointerId !== 'touch')) return;

        const deltaX = event.clientX - dragStartX;
        const deltaY = event.clientY - dragStartY;
        updateSwipeIntent(deltaX, deltaY, event);
      }

      function onPointerUp(event) {
        if (dragPointerId === null) return;

        const eventPointerId = event.pointerId === undefined ? 'mouse' : event.pointerId;
        if (dragPointerId !== eventPointerId && !(eventPointerId === 'mouse' && dragPointerId !== 'touch')) return;

        const deltaX = event.clientX - dragStartX;
        const deltaY = event.clientY - dragStartY;
        const didSwipe = isHorizontalSwipe(deltaX, deltaY);
        resetDrag();

        if (!didSwipe) return;

        go(deltaX < 0 ? 'next' : 'prev');
      }

      function onMouseDown(event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (dragPointerId !== null) return;
        if (!isSwipeTarget(event.target)) return;
        if (isTurning || shouldIgnoreDragTarget(event.target)) return;

        event.stopPropagation();
        dragPointerId = 'mouse';
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        book.classList.add(dragClass);
      }

      function onTouchStart(event) {
        if (dragPointerId !== null || isTurning || event.touches.length !== 1) return;
        if (shouldIgnoreDragTarget(event.target)) return;

        event.stopPropagation();
        const touch = event.touches[0];
        dragPointerId = 'touch';
        dragStartX = touch.clientX;
        dragStartY = touch.clientY;
        book.classList.add(dragClass);
      }

      function onTouchMove(event) {
        if (dragPointerId !== 'touch' || event.touches.length !== 1) return;

        const touch = event.touches[0];
        const deltaX = touch.clientX - dragStartX;
        const deltaY = touch.clientY - dragStartY;

        updateSwipeIntent(deltaX, deltaY, event);
      }

      function onTouchEnd(event) {
        if (dragPointerId !== 'touch') return;

        const touch = event.changedTouches[0];
        if (!touch) {
          resetDrag();
          return;
        }

        const deltaX = touch.clientX - dragStartX;
        const deltaY = touch.clientY - dragStartY;
        const didSwipe = isHorizontalSwipe(deltaX, deltaY);
        resetDrag();

        if (!didSwipe) return;

        go(deltaX < 0 ? 'next' : 'prev');
      }

      function onWheel(event) {
        if (isTurning) return;

        const usesShiftWheel = event.shiftKey && Math.abs(event.deltaY) >= dragThreshold;
        const deltaX = usesShiftWheel ? event.deltaY : event.deltaX;
        if (!usesShiftWheel && (Math.abs(deltaX) < dragThreshold || Math.abs(deltaX) < Math.abs(event.deltaY) * 1.15)) return;

        event.stopPropagation();
        event.preventDefault();
        go(deltaX > 0 ? 'next' : 'prev');
      }

      function syncMode() {
        clearTimeout(turnTimer);
        clearTimeout(settleTimer);
        pendingTurnFinish = null;
        queuedDirection = null;
        accelerateOnStart = false;
        isTurning = false;
        clearTurn();
        resetDrag();
        if (isMobileMode()) {
          currentPageIndex = Math.min(currentPageIndex, pages.length - 1);
          currentSpreadIndex = Math.floor(currentPageIndex / 2);
        } else {
          currentSpreadIndex = Math.floor(currentPageIndex / 2);
        }
        setSpreadVisibility(currentSpreadIndex);
        updateVisiblePages();
        updateControls();
      }

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        go('prev');
      }, true);
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        go('next');
      }, true);
      turn.addEventListener('animationend', (event) => {
        if (event.target === turn) {
          completePendingTurn();
        }
      });
      dragSurface.addEventListener('pointerdown', onPointerDown, true);
      book.addEventListener('pointerdown', onPointerDown, true);
      section.addEventListener('pointerdown', onPointerDown, true);
      dragSurface.addEventListener('pointermove', onPointerMove);
      dragSurface.addEventListener('pointerup', onPointerUp);
      dragSurface.addEventListener('pointercancel', resetDrag);
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', resetDrag);
      document.addEventListener('pointermove', onPointerMove, true);
      document.addEventListener('pointerup', onPointerUp, true);
      document.addEventListener('pointercancel', resetDrag, true);
      dragSurface.addEventListener('mousedown', onMouseDown, true);
      book.addEventListener('mousedown', onMouseDown, true);
      section.addEventListener('mousedown', onMouseDown, true);
      window.addEventListener('mousemove', onPointerMove);
      window.addEventListener('mouseup', onPointerUp);
      document.addEventListener('mousemove', onPointerMove, true);
      document.addEventListener('mouseup', onPointerUp, true);
      dragSurface.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
      book.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
      section.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
      dragSurface.addEventListener('touchmove', onTouchMove, { passive: false });
      dragSurface.addEventListener('touchend', onTouchEnd);
      dragSurface.addEventListener('touchcancel', resetDrag);
      document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
      document.addEventListener('touchend', onTouchEnd, true);
      document.addEventListener('touchcancel', resetDrag, true);
      dragSurface.addEventListener('wheel', onWheel, { passive: false, capture: true });
      dragSurface.addEventListener('dragstart', (event) => event.preventDefault());

      section.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') go('prev');
        if (event.key === 'ArrowRight') go('next');
      });

      if (typeof mobileMedia.addEventListener === 'function') {
        mobileMedia.addEventListener('change', syncMode);
      }

      syncMode();
    }

    function initLaunchFlipbooks(root = document) {
      root.querySelectorAll(flipbookSelector).forEach(initLaunchFlipbook);
    }

    initLaunchFlipbooks();

    document.addEventListener('shopify:section:load', (event) => {
      initLaunchFlipbooks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
